import React from 'react'
import Span from '@component/Text/Span'

interface IProps {
    className?: string
}

const NewTag = ({className}: IProps) => {
    return (
        <Span
            className={`text-white dark:text-bg_dark_background text-body_comm bg-primary dark:bg-dark_primary rounded-[3px] px-[5px] ${className}`}>
            New
        </Span>
    )
}
export default NewTag
